import { Button, Icon, Typography } from '@packages/ui/shared';
import { CVT } from '@packages/models/api/cvt';
import { DATE_FORMAT } from '@web/config/constants';
import { getDisplayDate } from '@web/utils/utils';
import { useTranslation } from 'react-i18next';

type DiagnosticCardRightSideContentProps = {
    diagnostic: CVT;
};

/**
 * The right side of a CVT diagnostic's radio card.
 *
 * Renders when the diagnostic completed, along with a button that opens the diagnostic in a new tab.
 */
export function DiagnosticCardRightSideContent({ diagnostic }: DiagnosticCardRightSideContentProps) {
    const { t } = useTranslation();

    function handleOpenDiagnostic() {
        openDiagnosticInNewTab(diagnostic.vin, diagnostic.diagnosticId);
    }

    return (
        <>
            {Boolean(diagnostic.jobCompletedTimestamp) && (
                <Typography color="textDarkSecondary" numberOfLines={1}>
                    {getDisplayDate(diagnostic.jobCompletedTimestamp, DATE_FORMAT.MMM_D_YEAR)}
                </Typography>
            )}

            <Button
                accessibilityLabel={t(
                    'qmr:sections.failCode.cvtDiagnostic.changeModal.openDiagnosticInNewTab',
                    'Open test in a new tab'
                )}
                onPress={handleOpenDiagnostic}
                size="small"
                variant="ghost-blue"
            >
                <Icon color="blueOne" name="open-in-new" />
            </Button>
        </>
    );
}

function openDiagnosticInNewTab(vin: string, diagnosticId: string) {
    window.open(`/vin/${vin}/cvt/${diagnosticId}`, '_blank', 'noopener,noreferrer');
}
